<template>
  <Form
    ref="queryForm"
    class="form-flex label-hide opacity"
    label-position="left"
    :label-width="80"
    :model="queryModel"
    :rules="rules"
    @submit.native.prevent
  >  
  <h2>疫苗險防疫險</h2>
    <DatePickerInput v-model="queryModel.vaccineInceptionDate" placeholder=" 年 / 月/ 日" label="生效日期" prop="vaccineInceptionDate" tip="保險生效日期為投保日+5天" :disabled="disabled" :readonly="disabled"/>    
    <p class="error">保險生效日期為投保日+5天</p>
    <BaseVueSelect
      v-if="type === 'vaccine'"
      v-model="queryModel.expectPremium"
      label="期望保費"
      prop="expectPremium"
      :options="options"     
    />    
    <div class="form-footer clearfix mb-s"> 
      <Button
        class="pull-right btn-primary btn-m btn-shadow"
        :loading="loading"
        @click="handleSubmit"
      >
        <span v-if="!loading">快速試算保費</span>
        <span v-else>請稍候</span>
      </Button>
    </div>
    <div class="notice">  
      <p>* 保險生效日期為投保日+5天，保險期間為選取時間零時起。</p>
      <p>* 投保年齡限制為20-75歲。</p>
      <p>* 依據法令規定未滿20歲者申請投保，請洽專員辦理。</p>
      <p>* 商品簡介僅供參考，詳細保單依保單條款為準，投保前應詳閱保單條款內容。</p>
    </div>
  </Form>
</template>

<script>
//import axios, { generateAuthPostConf  } from '@/utils/axios';
// date-fns
import differenceInCalendarDays from "date-fns/difference_in_calendar_days";
//import differenceInHours from "date-fns/difference_in_hours";
//import getTime from "date-fns/get_time";
// component
import { Form, Button } from "iview";
//import GroupRadio from "@/components/forms/elements/GroupRadio";
//import DateTimePickerInput from "@/components/forms/elements/DateTimePickerInput";
import DatePickerInput from "@/components/forms/elements/DatePickerInput";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
// options & radios
//import { abroad as radios } from "@/staticData/radios";
// default model
import {
  vaccineModel,  
  vaccineRules,
  options
} from "@/utils/asyncValidator/queryForms";
//import Cookies from 'js-cookie';
export default {
  components: {
    Form,
    Button,    
    DatePickerInput,
    BaseVueSelect
  },
  props: {
    model: {
      type: Object,
      default: () => vaccineModel
    }, 
    disabled: {
        type: Boolean,
        default: true
      },
    loading: {
      type: Boolean,
      default: false
    },
    handleQuery: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    const startTimeValidator = (rule, value, callback) => {
      const date =value;
      const diffter = differenceInCalendarDays(`${date}`, new Date());
      
      let errorMsg = [];
     
      if (isNaN(diffter)|| value=='') {        
        return callback(new Error("請選擇您疫苗險防疫險的生效日期!"));        
      }        
      //console.log(diffter);
      if (diffter < 1) {
        //Wen Add 2020/05/30 控制無法選擇過去的時間點       
        return callback(new Error("保險起始日是從零時起"));
      }
      callback();
    };
    const rules = {
      ...vaccineRules,      
      vaccineInceptionDate: { validator: startTimeValidator , trigger: "validate" }
    };
    const queryModel = this.$cloneDeep(this.model);   
    return {
      queryModel,      
      rules,
      options: options.expectPremium.vaccine,
    };
  },
  watch: {
    "queryModel.vaccineInceptionDate"() {
      const {
        queryModel: { vaccineInceptionDate }
      } = this;
     
    }
  },
  computed: {
    isEmpty() {
      const { startTime } = this.queryModel;
      return {
        start: Object.values(startTime).some(val => !val),        
      };
    },
    premiumLabel() {
      const {
        queryModel: { expectPremium },
        options
      } = this;
      if (!expectPremium) return null;
      const { label } = options.find(option => option.value === expectPremium);
      //console.log("expectPremium:" +expectPremium);
      return label;
    },
  },
  methods: {
    validate() {
      return this.$refs.queryForm.validate(v => v);
    },
    async handleSubmit() {
      const isValid = await this.validate();      
      if (!isValid) return;
      const { queryModel,premiumLabel } = this;
      const type = "vaccine";
      const tips = {  premiumLabel };
      this.handleQuery({ type,tips, ...queryModel });
    }    
  }
};
</script>
